module.exports = __webpack_public_path__ + "static/media/minniesLogo.04940eb5.PNG";